/**
 * Langues alignées sur `src/i18n/index.js` (`supportedLngs`, namespaces chargés).
 * Ne pas ajouter de code ici sans ajouter les fichiers de traduction correspondants.
 */
export const I18N_UI_LANGUAGE_OPTIONS = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'English' },
];

/** @param {string | undefined} code */
export function normalizeToSupportedUiLanguage(code) {
  const c = String(code || '')
    .toLowerCase()
    .split('-')[0];
  if (c === 'en') return 'en';
  return 'fr';
}

/** @param {string | undefined} code */
export function uiLanguageLabel(code) {
  const n = normalizeToSupportedUiLanguage(code);
  const hit = I18N_UI_LANGUAGE_OPTIONS.find((o) => o.value === n);
  return hit ? hit.label : n;
}
